import React from "react";
import SavedSearchSelect from "@/shared/components/ui/Select/SavedSearchSelect";
import QueryTextInput from "@/shared/components/ui/Input/QueryTextInput";
import type { SavedSearchItem } from "../../types";

const SavedSearchSelectComponent = SavedSearchSelect as React.ComponentType<any>;
const QueryTextInputComponent = QueryTextInput as React.ComponentType<any>;

interface ProspectQueryBarProps {
  queryName: string;
  value: string;
  onChange: (value: string) => void;
  onSearch: (query: string) => void;
  onNewSearch: () => void;
  savedSearches: SavedSearchItem[];
  selectedSavedId: string | number | null;
  onSelectSaved: (saved: SavedSearchItem) => void;
}

/** Same bar as Find accounts: saved searches on the left, the editable query on the right. */
export default function ProspectQueryBar({
  queryName,
  value,
  onChange,
  onSearch,
  onNewSearch,
  savedSearches,
  selectedSavedId,
  onSelectSaved,
}: ProspectQueryBarProps) {
  return (
    <div className="w-full rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 pl-4 min-h-[52px] flex items-center overflow-hidden shadow-xs">
      <SavedSearchSelectComponent
        searches={savedSearches}
        selectedId={selectedSavedId}
        placeholder={queryName}
        onSelect={onSelectSaved}
        onNewSearch={onNewSearch}
      />

      <div className="min-h-[52px] w-px self-stretch bg-gray-200 dark:bg-gray-700 shrink-0" />

      <div className="flex min-w-0 flex-1 self-stretch items-center bg-gray-50 dark:bg-gray-800/40 px-4 py-2">
        <QueryTextInputComponent
          value={value}
          onChange={onChange}
          onSubmit={onSearch}
          collapsible
          placeholder="Describe the people you want to find, then press Enter..."
          ariaLabel="Contact search query"
        />
      </div>
    </div>
  );
}
